if (!customElements.get('dontix-product-content')) {
  customElements.define('dontix-product-content', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced === 'true') return;
      const copy = this.querySelector('.dontix-product-copy');
      if (!copy) return;
      this.dataset.enhanced = 'true';
      const children = [...copy.childNodes];
      const groups = [];
      let group = { title: this.dataset.overview, nodes: [], open: true };
      const flush = () => {
        if (group.nodes.some(node => node.nodeType === 1 || node.textContent.trim())) groups.push(group);
      };
      children.forEach(node => {
        if (node.nodeType === 1 && /^H[23]$/.test(node.tagName)) {
          flush();
          group = { title: node.textContent.trim(), nodes: [], open: false };
        } else if (node.nodeType === 1 && node.matches('section.bracket-prescription')) {
          flush();
          const heading = node.querySelector('h2');
          group = { title: heading ? heading.textContent.trim() : this.dataset.overview, nodes: [node], open: false };
          if (heading) heading.remove();
          flush();
          group = { title: this.dataset.notes, nodes: [], open: false };
        } else group.nodes.push(node);
      });
      flush();
      if (!groups.length) return;
      const fragment = document.createDocumentFragment();
      groups.forEach(item => {
        const details = document.createElement('details');
        details.className = 'dontix-detail-row';
        details.open = item.open;
        const summary = document.createElement('summary');
        summary.textContent = item.title;
        const content = document.createElement('div');
        content.className = 'dontix-detail-row__content';
        item.nodes.forEach(node => content.append(node));
        details.append(summary, content);
        fragment.append(details);
      });
      copy.replaceChildren(fragment);
      copy.querySelectorAll('table').forEach(table => {
        if (table.closest('.prescription-scroll, .dontix-table-scroll')) return;
        const scroll = document.createElement('div');
        scroll.className = 'dontix-table-scroll';
        table.before(scroll);
        scroll.append(table);
      });
    }
  });
}
